























































import { defineComponent, ref, computed, PropType, toRefs } from '@vue/composition-api';
import {
  DestinationUrlType,
  ParamsTypesEnum,
  AdgroupFormData,
  FullNormalFormData,
  AcoFormData,
  CampaignFormData,
} from '@tt4b/ttam-enums';
import TtamCreativeUtmDialog from '../utm-dialog/index.vue';
import { useAllowlist } from '@tt4b/ttam-hooks';

const name = 'ttam-creative-utm-entry';
export default defineComponent({
  name,
  components: {
    TtamCreativeUtmDialog,
  },
  props: {
    url: {
      type: String,
      default: '',
    },
    isDlp: {
      type: Boolean,
      default: false,
    },
    isEntryNewUI: {
      type: Boolean,
      default: false,
    },
    isOpenUrl: {
      type: Boolean,
      default: false,
    },
    isVsa: {
      type: Boolean,
      default: true,
    },
    isLegacy: {
      type: Boolean,
      default: false,
    },
    isLibraOn: {
      type: Boolean,
      default: false,
    },
    isDisableEdit: {
      type: Boolean,
      default: false,
    },
    originalQuery: {
      type: Array,
      default: () => [],
    },
    isProductDeeplink: {
      type: Boolean,
      default: false,
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const dialogVisible = ref(false);
    const { adgroupData, creativeData } = toRefs(props);
    const { isUtmBuilderWhite } = useAllowlist();
    const urlType = computed(() => creativeData.value.destinationUrlType);
    const paramsType = computed(() => creativeData.value.paramsType);
    const objectiveType = computed(() => adgroupData.value.objectiveType);
    const showBuilder = computed(() => {
      if (props.isVsa) {
        return props.isLegacy || isUtmBuilderWhite.value;
      } else {
        return props.isLibraOn;
      }
    });

    const utms = computed(() => {
      const currentUtms = props.isOpenUrl ? creativeData.value.openUrlUtms : creativeData.value.utms;

      return (currentUtms || []).map(({ field, value }) => `${field}=${value}`).join('&');
    });
    const handleApplyUtm = newParams => {
      emit('apply', newParams);
    };

    const trackData = computed(() => {
      let data = {
        'data-tea-destination_type': '',
        'data-tea-objective_type': objectiveType.value,
      };
      if (props.isDlp) {
        data['data-tea-destination_type'] = 'dynamic destination on';
        return data;
      }
      if (urlType.value === DestinationUrlType.instantPage) {
        data['data-tea-destination_type'] = 'Instant product page';
        return data;
      }
      if (urlType.value === DestinationUrlType.webSite) {
        data['data-tea-destination_type'] =
          paramsType.value === ParamsTypesEnum.ProductDeepLink ? 'product link' : 'website link';
        return data;
      }
      return data;
    });

    return {
      name,
      dialogVisible,
      utms,
      handleApplyUtm,
      showBuilder,
      trackData,
      urlType,
      paramsType,
    };
  },
});
